import { Badge, Flex, Text,  } from "@mantine/core"
import colors from "../utils/colors"
import { useLanguage } from "../context/LanguageContext";

export const AttendanceBadge: React.FC<{ title: string, period: string, count: number }> = ({ title, period, count }) => {

    const { translate } = useLanguage();
  
    return (
      <Flex direction="column" gap={3} w={'max-content'} align="center">
        <Flex direction="column" align="center">
          <Text c={colors.custom36p} fw={500} fz="14" mb={-5}>{title}</Text>
          <Text c={colors.custom36p} fw={700} fz="h5">{period}</Text>
        </Flex>
        <Badge variant="gradient" gradient={{ from: `#1db90e`, to: `${colors.green}ee`, deg: 0 }} radius="lg" size="md" fz="16">{count } {translate('days')}</Badge>
      </Flex>
    )
  }